import {Injectable} from '@angular/core';
import {randomUUIDGenerator} from 'app/core/helpers/uuid';
import {LocalStorageService} from 'app/core/services/local-storage.service';
import {boolDevFlag} from 'test-helpers/dev-flags';

const DisableTraceId = 'disableTraceId';

@Injectable({
    providedIn: 'root',
})
export class TraceService {
    private currentTraceId: string;
    private isDisabledByFlag = false;

    get traceId(): string {
        if (this.isDisabledByFlag) {
            return '';
        }
        return this.currentTraceId;
    }

    constructor(private localStorage: LocalStorageService) {
        this.checkDisablingFlags();
        this.next();
    }

    next() {
        // eslint-disable-next-line @typescript-eslint/no-magic-numbers
        return (this.currentTraceId = randomUUIDGenerator().split('-').join('').slice(2, 18));
    }

    checkDisablingFlags() {
        window.location.search
            .slice(1)
            .split('&')
            .forEach(elm => {
                if (elm === '') {
                    return;
                }
                const [name, value] = elm.split('=');
                if (name === DisableTraceId) {
                    this.localStorage.setItem(name, value);
                }
            });

        this.isDisabledByFlag = boolDevFlag(DisableTraceId, false, this.localStorage);
    }
}
